import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import HighlightText from './HighlightText';

const faqs = [
  { q: 'How can I find the best home tutor in Lucknow near me?', a: 'You can easily find qualified home tutors across Lucknow based on your location, class, and subject. Simply request a tutor, and we match you with verified teachers near your area.' },
  { q: 'Do you provide home tutors in all areas of Lucknow?', a: 'Yes, we offer home tuition services across all major areas including Gomti Nagar, Indira Nagar, Aliganj, Jankipuram, and nearby locations.' },
  { q: 'Is a free demo class available before hiring a tutor?', a: 'Yes, we offer a free demo class so you can evaluate the tutor’s teaching style, communication, and subject clarity before making a decision.' },
  { q: 'What classes and subjects do your home tutors cover?', a: 'Our tutors cover all classes from Nursery to 12th, college-level subjects, and competitive exams like JEE, NEET, and more.' },
  { q: 'How are tutors verified before being assigned?', a: 'Every tutor goes through a strict screening process including qualification checks, subject expertise evaluation, and background verification.' },
  { q: 'Can I choose a tutor based on my preferred timing?', a: 'Yes, we offer flexible scheduling. You can choose timings that suit your daily routine, including evenings and weekends.' },
  { q: 'How quickly can I get a home tutor in Lucknow?', a: 'In most cases, we can connect you with a suitable tutor within 24–48 hours after your request.' },
  { q: 'Do you offer both home tuition and online classes?', a: 'Yes, you can choose between in-home tutoring or online classes depending on your preference and convenience.' },
  { q: 'What if I am not satisfied with the tutor?', a: 'If you are not satisfied after the demo or initial classes, we can replace the tutor with a better match at no extra cost.' },
  { q: 'Are your tutors experienced and qualified?', a: 'Yes, our tutors are experienced professionals, subject experts, and trained educators with proven teaching backgrounds.' },
  { q: 'Can I request a female home tutor?', a: 'Absolutely. We provide qualified female tutors, and you can choose based on your preference during the booking process.' }
];

const FAQItem = ({ faq, isOpen, onClick }) => (
  <div className={`border ${isOpen ? 'border-red-200 bg-red-50/30' : 'border-gray-100 bg-white'} rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 mb-4 overflow-hidden`}>
    <button 
      className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none"
      onClick={onClick}
    >
      <span className="font-extrabold text-slate-800 text-lg pr-4">{faq.q}</span>
      <div className={`w-8 h-8 rounded-full ${isOpen ? 'bg-primary text-white' : 'bg-red-50 text-primary'} flex items-center justify-center flex-shrink-0 transition-colors duration-300`}>
        <FiChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </div>
    </button>
    <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`}>
      <p className="text-gray-600 font-medium leading-relaxed">{faq.a}</p>
    </div>
  </div>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="py-24 bg-[#fdf8f4]" id="faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight">
            Frequently Asked <HighlightText>Questions</HighlightText>
          </h2>
          <p className="text-gray-500 font-medium">
            Have questions? We're here to help you understand how our service works.
          </p>
        </div>
        <div>
          {faqs.map((faq, idx) => (
            <FAQItem 
              key={idx} 
              faq={faq} 
              isOpen={idx === openIdx} 
              onClick={() => setOpenIdx(idx === openIdx ? -1 : idx)} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;